import { Typography } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 32px;
  align-items: center;
  justify-content: center;
`;

export interface HeaderBlockProps {
  title: string;
  description?: string;
}

export default function HeaderBlock({ title, description }: HeaderBlockProps) {
  let desc;
  if (description) {
    desc = <Typography>{description}</Typography>;
  }
  return (
    <Container>
      <Typography variant="h4">{title}</Typography>
      {desc}
    </Container>
  );
}
